import { Component, Prop } from 'vue-property-decorator'

import { Mixins } from 'vue-mixin-decorator'
import MixinInterface from '@/_mixins/index'
import UserMixin from '@/_mixins/user'

import ProjectAvatar from '@/components/Avatar/Project/Avatar.vue'

@Component({
    components: { ProjectAvatar },
    mixins: [UserMixin],
})
export default class ProjectListItem extends Mixins<MixinInterface>(UserMixin) {
    @Prop({ default: 30 }) size!: number

    get project() {
        return this.$route.params.type == 'p'
            ? this.$store.getters.project(this.$route.params.id)
            : null
    }

    get group() {
        return this.$route.params.type == 'g'
            ? this.$store.getters.group(this.$route.params.id)
            : null
    }

    get name() {
        return this.project ? this.project?.attributes.name : this.group?.attributes.name
    }

    get company() {
        return this.project?.relationships.owner?.data?.id
            ? this.$store.getters.projectCompany(this.project.relationships.owner.data.id)
                  ?.attributes?.name
            : null
    }
}
